<script>
  import BaseList from '../list.vue';

  export default {
    extends: BaseList,
  }
</script>

